import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import Ls from "@/services/ls";

let restaurant = Ls.get('restaurant')

const initialState = {
    restaurant: restaurant ? JSON.parse(restaurant) : {},
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}